import { Text } from '@chakra-ui/react';
import CockpitDialog, { CockpitDialogProps } from '@components/cockpit/CockpitDialog';
import { FormattedMessage } from 'react-intl';

type CockpitFormSaveDialogProps = {
  isNewElement: boolean;
  name: string | undefined;
  saveNewLabel: string;
  saveUpdateLabel: string;
} & Omit<CockpitDialogProps, 'children'>;

export function CockpitFormSaveDialog({
  open,
  isLoading,
  confirmLabel,
  cancelLabel,
  onConfirm,
  onCancel,
  isNewElement,
  name,
  saveNewLabel,
  saveUpdateLabel,
}: Readonly<CockpitFormSaveDialogProps>) {
  return (
    <CockpitDialog
      open={open}
      isLoading={isLoading}
      confirmLabel={confirmLabel}
      cancelLabel={cancelLabel}
      onConfirm={onConfirm}
      onCancel={onCancel}
    >
      <Text color="neutral.100" width="100%" whiteSpace="pre-line">
        <FormattedMessage id={isNewElement ? saveNewLabel : saveUpdateLabel} values={{ name }} />
      </Text>
    </CockpitDialog>
  );
}
